import _ from "lodash";
import { formatDate, formatDateNew } from "../filters";
import * as emailjs from "emailjs-com";

import {
  firebase,
  packages,
  sections,
  requests,
  storage,
  news,
  newCategories,
  userAdminLogin,
  userLogin,
  programs,
} from "../firebase.config";

export const loadPackages = ({ commit }) => {
  packages
    .orderBy("price")
    .get()
    .then((querySnapshot) => {
      const docs = querySnapshot.docs;

      let packages = _.map(docs, (doc) => {
        return Object.assign(
          {
            id: doc.id,
          },
          doc.data()
        );
      });

      commit("updatePackages", packages);
    });
};

export const loadCategories = ({ commit }) => {
  sections
    .doc("home")
    .collection("categories")
    .get()
    .then((querySnapshot) => {
      const docs = querySnapshot.docs;

      let categories = _.map(docs, (doc) => {
        return Object.assign(
          {
            id: doc.id,
          },
          doc.data()
        );
      });

      commit("updateHomeCategories", categories);
    });
};

export const loadNews = ({ commit }) => {
  return news.get().then((querySnapshot) => {
    const documents = querySnapshot.docs;
    const news = documents.map((d) => {
      return {
        id: d.id,
        ...d.data(),
      };
    });

    return commit("updateNews", news);
  });
};
export const loadNewCategories = ({ commit }) => {
  return newCategories.get().then((querySnapshot) => {
    const documents = querySnapshot.docs;
    const newCategories = documents.map((d) => {
      return {
        id: d.id,
        ...d.data(),
      };
    });
    debugger
    return commit("updateNewCategories", newCategories);
  });
};
export const loadUsers = ({ commit }) => {
  return userLogin.get().then((querySnapshot) => {
    const documents = querySnapshot.docs;
    const users = documents.map((d) => {
      return {
        id: d.id,
        ...d.data(),
      };
    });

    return commit("updateUsers", users);
  });
};
export const loadAdmin = ({ commit }) => {
  return userAdminLogin.get().then((querySnapshot) => {
 
    const documents = querySnapshot.docs;
    const users = documents.map((d) => {
      return {
        id: d.id,
        ...d.data(),
      };
    });
  
    return commit("updateUserAdmin", users);
  });
};
export const RemoveNew = async (store, obj) => {
  try {
    await news.doc(obj.id).delete();
    return true;
  } catch (e) {
    return false;
  }
};

export const loginMethod = async (context, obj) => {
  return userLogin
    .get()
    .then((querySnapshot) => {
      const documents = querySnapshot.docs;
      const users = documents.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });

      const user = users.find(
        (u) =>
          u.identificationCard === obj.identificationCard &&
          u.password === obj.password
      );

      context.commit("updateUser", user);
      return user;
    })
    .catch((e) => {
      return false;
    });
};
export const registerMethod = async (store, obj) => {
  try {
    // var sha = sha1(obj.password);
    // obj.password = sha;
    // obj.repitPassword = sha;
    await userLogin.doc().set(obj);

    return true;
  } catch (e) {
    console.log(e.toString());
    return false;
  }
};
export const updateUser = async (context, obj) => {
  try {
    await userLogin.doc(obj.id).set(obj);
    context.commit("updateUser", obj);
    return true;
  } catch (e) {
    console.log(e.toString());
    return false;
  }
};
export const loadCarousel = ({ commit }) => {
  sections
    .doc("home")
    .get()
    .then((documentSnapshot) => {
      const carousel = documentSnapshot.data()["carousel"];

      commit("updateHomeCarousel", carousel);
    });
};
export const loadCarouselMovil = ({ commit }) => {
  return programs
    .where("section", "==", "CAROUSEL")
    .get()
    .then((querySnapshot) => {
      const documents = querySnapshot.docs;
      const carousel = documents.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });

      return commit("updateMovilCarousel", carousel);
    });
};
export const addImagenMovil = async (store, obj) => {
  await programs.doc().set(obj);
};
export const delateCarouselMovil = async (store, obj) => {
  try {
    await programs.doc(obj.id).delete();
    return true;
  } catch (e) {
    return false;
  }
};

export const addImagen = async (store, obj) => {
  const url = obj.obj;
  await sections.doc("home").update({
    carousel: firebase.firestore.FieldValue.arrayUnion(url),
  });
};

export const delateCarousel = async (store, obj) => {
  try {
    await sections.doc("home").update({
      carousel: firebase.firestore.FieldValue.arrayRemove(obj.obj),
    });
    return true;
  } catch (e) {
    return false;
  }
};

export const uploadImage = async (store, obj) => {
  try {
    const response = await storage.ref(obj.obj.name).put(obj.obj);

    const url = await response.ref.getDownloadURL();
    // console.log("archivo disponible en ", url);

    return url;
  } catch (e) {
    return false;
  }
};

export const loadContact = ({ commit }) => {
  sections
    .doc("contact")
    .get()
    .then((documentSnapshot) => {
      const contact = documentSnapshot.data();

      commit("updateContact", contact);
    });
};

export const loadAboutSections = ({ commit }) => {
  sections
    .doc("about")
    .collection("sections")
    .get()
    .then((querySnapshot) => {
      const docs = querySnapshot.docs;

      let sections = _.map(docs, (doc) => {
        return Object.assign(
          {
            id: doc.id,
          },
          doc.data()
        );
      });

      commit("updateAboutSections", sections);
    });
};

export const loadRequests = ({ commit }) => {
  requests
    .orderBy("created", "desc")
    .get()
    .then((querySnapshot) => {
      const docs = querySnapshot.docs;

      let requests = _.map(docs, (doc) => {
        let result = {
          ...doc.data(),
          id: doc.id,
        };
        return result;
      });

      commit("updateRequests", requests);
    });
};

export const makePackageRequest = ({ commit }, request) => {
  requests.add({
    ...request,
    type: "PACKAGE",
    created: firebase.firestore.Timestamp.fromDate(new Date()),
  });
};
export const updateRequestsClaim = async (context, obj) => {
  try {

    await requests.doc(obj.id).set(obj);

    return true;
  } catch (e) {
    console.log(e.toString());
    return false;
  }
};
export const makeContactRequest = ({ commit }, request) => {
 if (request.type==="CLAIM"){
   sendEmail()

 }
  return requests.add({
    ...request,
    type: request.type=="Reporte de avería"? "CLAIM":"CONTACT",
    created: firebase.firestore.Timestamp.fromDate(new Date()),
  });
};

export const singOutAction = ({ commit }) => {
  
  commit("clearUser");
};

// export const linstingUpdateRequestClaim=({ commit })=>{
  
//   requests.where("type", "==", "CLAIM")
//     .onSnapshot((snapshot) => {
//         snapshot.docChanges().forEach((change) => {
//             if (change.type === "added") { 
         
//              console.log(change.doc.data())

//                 if(formatDateNew(change.doc.data().created)==formatDate( Date.now())){
//                   console.log("New CLAIM: ", change.doc.data());
//                      sendEmail();
//                 }

//             }
//             if (change.type === "modified") {
            
//                 console.log("Modified item: ", change.doc.data());
//             }
//             if (change.type === "removed") {
//                 console.log("Removed item: ", change.doc.data());
//             }
//         });
//     });
// }
// export const linstingUpdateRequestPACKAGE=({ commit })=>{
  
//   requests.where("type","==","PACKAGE")
//     .onSnapshot((snapshot) => {
//         snapshot.docChanges().forEach((change) => {
//             if (change.type === "added") { 
          
//                 if(formatDateNew(change.doc.data().created)==formatDate( Date.now())){
//                   console.log("New PACKAGE: ", change.doc.data());
//                      sendEmail();
//                 }

//             }
//             if (change.type === "modified") {
            
//                 console.log("Modified item: ", change.doc.data());
//             }
//             if (change.type === "removed") {
//                 console.log("Removed item: ", change.doc.data());
//             }
//         });
//     });
// }

export const sendEmail=()=> {
  emailjs.init("user_Qknfqs7fZAnVh2oqvZrqB");
  emailjs.send("service_tk4wuxf", "template_pntgxvr", {}).then(
    (result) => {
      console.log("SUCCESS!", result.status, result.text);
    },
    (error) => {
      console.log("FAILED...", error);
    }
  );
};